import { List, Map } from 'immutable'
import 'store/types'
import { GIFT_PLANS_ID_MAP } from '.'
import './types'

/**
 * @param {ReduxStore} store
 * @return {String} currency ISO
 */
export function selectCurrencyIso ({ plans }) {
  return plans.getIn(['data', 'plans', 0, 'currencyIso'])
}

/**
 * @param {import('immutable').List<String>} SKU static store key
 * @returns {selectPlansBySku~selectFromState}
 */
export function selectPlansBySku (skus) {
  /**
   * @param {ReduxState} state redux state
   * @returns {import('immutable').List<Plan>}
   */
  const selectFromState = ({ plans: plansState }) => {
    const plansList = plansState.getIn(['data', 'plans'], List())
    return plansList.filter((plan) => skus.includes(plan.get('sku')))
  }

  return selectFromState
}

/**
 * @param {import('immutable').List<String>} planId static store key
 * @returns {selectPlansBySku~selectFromState}
 */
export function selectPlanByPlanId (planId) {
  /**
   * @param {ReduxState} state redux state
   * @returns {import('immutable').List<Plan>}
   */
  const selectFromState = ({ plans: plansState }) => {
    return plansState.getIn(['data', 'plans'], List()).find((p) => p.get('id') === planId)
  }

  return selectFromState
}

export function selectGiftPlanByPlanId (planId) {
  /**
   * @param {ReduxState} state redux state
   * @returns {import('immutable').Map<Plan>}
   */
  const selectFromState = ({ plans: plansState }) => {
    return plansState.getIn(['data', 'plans'], List()).find((p) => p.get('id') === GIFT_PLANS_ID_MAP.get(planId))
  }

  return selectFromState
}

/**
 * @param {import('immutable').List<String>} planId static store key
 * @returns {selectPlansBySku~selectFromState}
 */
export function selectPlansByPlanIds (planIds) {
  /**
   * @param {ReduxState} state redux state
   * @returns {import('immutable').List<Plan>}
   */
  const selectFromState = ({ plans: plansState }) => {
    if (!planIds || !planIds.size) return List()
    const plans = planIds.map((planId) => plansState.getIn(['data', 'plans'], List()).find((p) => p.get('id') === GIFT_PLANS_ID_MAP.get(planId)))
    return plans.filter((plan) => !!plan)
  }

  return selectFromState
}

/**
 * @param {ReduxStore} store
 * @return {Boolean}
 */
export function selectPlansLoaded ({ plans }) {
  return plans.getIn(['data', 'plans'], List()).size > 0
}

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectPlans (state) {
  return state.plans || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasSelectedPlan (state) {
  const selectedPlans = selectPlans(state).get('selection') || Map()
  return Map.isMap(selectedPlans) && selectedPlans.size > 0
}
